import axios from 'axios'
import qs from 'qs'
import yhconfig from '@/yhconfig.js'

axios.defaults.timeout = 100000 // 设置请求时间
// axios.defaults.withCredentials = true /** *允许跨域请求 */

// 响应拦截器
axios.interceptors.response.use((response)=> {
  // 对响应数据做点什么
  if(response.data.code === 401){
    sessionStorage.removeItem("usertoken")
    sessionStorage.removeItem("username")
    window.location.href = "/";
  }
  return response.data;
});

// //接口地址
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = yhconfig.apiurl;  //设置默认请求地址
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = yhconfig.apiurl;  //设置默认请求地址
}

/**
 * 封装get方法
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }, {
      headers: {
        // 'Content-Type': 'application/json'
        // 'content-type': 'application/x-www-form-urlencoded',
      }
    })
      .then(response => {
        if (response.code != 0) {
          reject(response)
        }
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 */
export function post(url, data = {}, ctype = 'x-www-form-urlencoded') {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      headers: {
        'content-type': ctype,
      }
    })
      .then(response => {
        // console.log(response)
        if (response.code != 0) {
          reject(response)
        }
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (response.data.code == 505) {
          setTimeout(() => {
            router.replace({
              path: '/',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
          }, 1500)
          Message({
            message: 'token过期或错误,请重新登录',
            type: 'warning'
          })
          // localStorage.clear()
          return false
        }
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装DELETE请求
 */
export function del(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        // console.log(response)
        if (response.code != 0) {
          reject(response)
        }
        resolve(response)
      }, err => {
        reject(err)
      })

  })
}

// 从url串中提取参数值
export function getUrlParam(url, param) {
  if (url.indexOf("?") != -1)
    url = url.substr(1);
  var reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
  var r = url.match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 级联数组中查找元素
export function dictone(arr, item) {
  if (item == null)
    return arr[0]
  for (let i = 0; i < arr.length; i++)
    if (arr[i] == item)
      if (i + 1 == arr.length)
        return arr[0]
      else
        return arr[i + 1]
}

export function formatDate(date) {
  var json_date = new Date(date).toJSON();
  var aaa = new Date(+new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  aaa = aaa.split(' ')[0]
  return aaa;
}

export function formatDatetime(date) {
  var json_date = new Date(date).toJSON();
  var aaa = new Date(+new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  return aaa;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = []
  Object.keys(datas).map(key => {
    if (datas[key].value === '' + value) {
      actions.push(datas[key].text)
      return false
    }
  })
  return actions.join('')
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return axios.get( '/system/dict/data/dictType/' + dictType).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/common/request.js